import Flex from "@/components/Flex";
import Text from "@/components/Text";
import { PRIMITIVE, px } from "@/tokens/design-tokens";
import {
  SCRIBE_LIVE_TRANSCRIPT_LABELS,
  SCRIBE_V2_COLORS,
  SCRIBE_V2_DIMENSIONS,
} from "../constants";
import ListeningWaveIcon from "./ListeningWaveIcon";

const ListeningIndicator = () => (
  <Flex
    role="status"
    alignItems="center"
    gap={1}
    px={px(PRIMITIVE.spacing[12])}
    py={px(PRIMITIVE.spacing[8])}
    sx={{
      alignSelf: "flex-start",
      borderRadius: SCRIBE_V2_DIMENSIONS.bubbleRadius,
      border: `1px dashed ${SCRIBE_V2_COLORS.noteCardBorder}`,
    }}
  >
    <ListeningWaveIcon color={SCRIBE_V2_COLORS.textMuted} />
    <Text
      sx={{
        color: SCRIBE_V2_COLORS.textMuted,
        fontSize: px(PRIMITIVE.typography.fontSize.body.b5),
      }}
    >
      {SCRIBE_LIVE_TRANSCRIPT_LABELS.LISTENING}
    </Text>
  </Flex>
);

export default ListeningIndicator;
